// pages/AdminDashboard.js - Versione Mobile-First Professionale con NUOVI FRONTEND AI
import React from "react";
import { 
  Box, 
  Typography, 
  Grid, 
  Paper, 
  Avatar, 
  Stack,
  Chip,
  Card,
  CardContent,
  CardActionArea,
  Container,
  Fade,
  useTheme,
  useMediaQuery,
  IconButton,
  Divider
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { useBranding } from "../context/DomainContext";
import { Link as RouterLink } from "react-router-dom";
import { 
  LayoutDashboard, 
  User, 
  Settings, 
  Zap,
  FileText,
  MessageSquare,
  BrainCircuit,
  ChevronRight,
  Activity,
  Shield,
  Palette
} from "lucide-react";
import GavelIcon from "@mui/icons-material/Gavel";
import BuildIcon from "@mui/icons-material/Build";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ChatIcon from "@mui/icons-material/Chat";
import CreateIcon from "@mui/icons-material/Create";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import BugReportIcon from "@mui/icons-material/BugReport";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SportsIcon from "@mui/icons-material/Sports";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import ConstructionIcon from "@mui/icons-material/Construction";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
// Nuove icone per i frontend AI
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import DescriptionIcon from "@mui/icons-material/Description";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";

// Configurazione delle sezioni con design compatto - AGGIUNTI NUOVI FRONTEND AI
const ADMIN_SECTIONS = {
  dashboards: {
    title: "Dashboard",
    color: "primary",
    icon: <LayoutDashboard size={20} />,
    links: [
      { 
        to: "/admin/SystemDashboard", 
        label: "Sistema", 
        icon: <LayoutDashboard size={18} />,
        description: "Panoramica piattaforma"
      },
      { 
        to: "/admin/ProjectDashboard", 
        label: "Progetto", 
        icon: <AccountTreeIcon sx={{ fontSize: 18 }} />,
        description: "Metriche progetto"
      }
    ]
  },
  management: {
    title: "Gestione",
    color: "secondary",
    icon: <Settings size={20} />,
    links: [
      { 
        to: "/admin/projects", 
        label: "Progetti", 
        icon: <BuildIcon sx={{ fontSize: 18 }} />,
        description: "Amministra progetti"
      },
      { 
        to: "/admin/project-agents-structure", 
        label: "Agents Progetto", 
        icon: <GroupWorkIcon sx={{ fontSize: 18 }} />,
        description: "Gestione agents progetto"
      },
      { 
        to: "/admin/system-templates", 
        label: "Template", 
        icon: <CreateIcon sx={{ fontSize: 18 }} />,
        description: "Template sistema"
      },
      { 
        to: "/admin/system-policies", 
        label: "Policy", 
        icon: <GavelIcon sx={{ fontSize: 18 }} />,
        description: "Blueprint policy"
      },
      { 
        to: "/admin/system-agent-blueprints", 
        label: "Blueprints", 
        icon: <SmartToyIcon sx={{ fontSize: 18 }} />,
        description: "Agenti blueprint"
      }
    ]
  },
  ai_frontends: {
    title: "Frontend AI Innovativi",
    color: "success",
    icon: <BrainCircuit size={20} />,
    links: [
      { 
        to: "/ai/workspace-collaborativo", 
        label: "AI Workspace", 
        icon: <WorkspacesIcon sx={{ fontSize: 18 }} />,
        description: "Team AI collaborativo"
      },
      { 
        to: "/ai/document-intelligence-studio", 
        label: "Document Studio", 
        icon: <DescriptionIcon sx={{ fontSize: 18 }} />,
        description: "Analisi documenti AI"
      },
      { 
        to: "/ai/agent-orchestrator", 
        label: "Agent Orchestrator", 
        icon: <DashboardCustomizeIcon sx={{ fontSize: 18 }} />,
        description: "Centro controllo agenti"
      }
    ]
  },
  tools: {
    title: "Strumenti",
    color: "info",
    icon: <BrainCircuit size={20} />,
    links: [
      { 
        to: "/admin/agent-creator", 
        label: "Agent Creator", 
        icon: <SmartToyIcon sx={{ fontSize: 18 }} />,
        description: "Crea agenti"
      },
      { 
        to: "/admin/agents-builder", 
        label: "Agents Builder", 
        icon: <ConstructionIcon sx={{ fontSize: 18 }} />,
        description: "Sistema avanzato agenti"
      },
      { 
        to: "/user/file-manager", 
        label: "File Manager", 
        icon: <UploadFileIcon sx={{ fontSize: 18 }} />,
        description: "Gestione file"
      },
      { 
        to: "/user/chat-page", 
        label: "Executive", 
        icon: <ChatIcon sx={{ fontSize: 18 }} />,
        description: "Chat esecutiva"
      },
      { 
        to: "/user/chat-page-committee", 
        label: "Committee", 
        icon: <ChatBubbleOutlineIcon sx={{ fontSize: 18 }} />,
        description: "Chat committee"
      },
      { 
        to: "/user/committee-room", 
        label: "Committee Room", 
        icon: <MeetingRoomIcon sx={{ fontSize: 18 }} />,
        description: "Workspace collaborativo"
      },
      { 
        to: "/user/chat-ux", 
        label: "Brainstorming", 
        icon: <BugReportIcon sx={{ fontSize: 18 }} />,
        description: "Sessioni creative"
      },
      { 
        to: "/user/battle-arena", 
        label: "Battle Arena", 
        icon: <SportsIcon sx={{ fontSize: 18 }} />,
        description: "Competizione AI"
      }
    ]
  }
};

// Componente compatto per link mobile-first
const CompactAdminCard = ({ link, sectionColor }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Card 
      elevation={0}
      sx={{ 
        height: isMobile ? '80px' : '100px',
        transition: 'all 0.2s ease-in-out',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        '&:hover': { 
          transform: 'translateY(-2px)',
          boxShadow: theme.shadows[4],
          borderColor: theme.palette[sectionColor]?.main || theme.palette.primary.main
        }
      }}
    >
      <CardActionArea 
        component={RouterLink} 
        to={link.to}
        sx={{ 
          p: isMobile ? 1.5 : 2, 
          height: '100%',
          display: 'flex',
          flexDirection: isMobile ? 'row' : 'column',
          alignItems: isMobile ? 'center' : 'flex-start',
          justifyContent: isMobile ? 'flex-start' : 'center',
          textDecoration: 'none',
          gap: isMobile ? 1.5 : 1
        }}
      >
        <Box 
          sx={{ 
            p: isMobile ? 0.75 : 1,
            borderRadius: 1.5,
            backgroundColor: `${theme.palette[sectionColor]?.main || theme.palette.primary.main}15`,
            color: theme.palette[sectionColor]?.main || theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: isMobile ? '40px' : 'auto',
            minHeight: isMobile ? '40px' : 'auto'
          }}
        >
          {link.icon}
        </Box>
        
        <Box sx={{ flex: 1, textAlign: isMobile ? 'left' : 'center' }}>
          <Typography 
            variant={isMobile ? "subtitle2" : "subtitle1"}
            fontWeight="bold" 
            sx={{ 
              color: 'text.primary',
              mb: isMobile ? 0 : 0.5,
              lineHeight: 1.2
            }}
          >
            {link.label}
          </Typography>
          
          {!isMobile && (
            <Typography 
              variant="caption" 
              color="text.secondary"
              sx={{ 
                display: 'block',
                lineHeight: 1.2
              }}
            >
              {link.description}
            </Typography>
          )}
        </Box>

        {isMobile && (
          <ChevronRight 
            size={16} 
            color={theme.palette.text.secondary}
          />
        )}
      </CardActionArea>
    </Card>
  );
};

// Componente sezione con design compatto
const CompactAdminSection = ({ section, sectionKey }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box sx={{ mb: isMobile ? 3 : 4 }}>
      <Stack 
        direction="row" 
        spacing={1.5} 
        alignItems="center" 
        sx={{ mb: isMobile ? 1.5 : 2 }}
      >
        <Box 
          sx={{ 
            p: 1,
            borderRadius: 1.5,
            backgroundColor: `${theme.palette[section.color]?.main || theme.palette.primary.main}15`,
            color: theme.palette[section.color]?.main || theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {section.icon}
        </Box>
        <Typography 
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold" 
          color="text.primary"
          sx={{ flex: 1 }}
        >
          {section.title}
        </Typography>
        <Chip 
          label={section.links.length}
          size="small"
          color={section.color}
          variant="outlined"
          sx={{ minWidth: '32px' }}
        />
      </Stack>
      
      <Grid container spacing={isMobile ? 1.5 : 2}>
        {section.links.map((link) => (
          <Grid 
            key={link.to} 
            item 
            xs={12} 
            sm={6} 
            md={4} 
            lg={isMobile ? 12 : 3}
          >
            <CompactAdminCard link={link} sectionColor={section.color} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default function AdminDashboard() {
  const { profile } = useAuth();
  const { projectName, logoUrl } = useBranding();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  if (!profile?.is_platform_admin) {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Paper elevation={2} sx={{ p: 3, textAlign: 'center', borderRadius: 2 }}>
          <Typography variant="h5" color="error" gutterBottom>
            Accesso Negato
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Non hai i permessi necessari per accedere a questa area.
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container 
      maxWidth="xl" 
      sx={{ 
        py: isMobile ? 2 : 3,
        px: isMobile ? 1 : 2
      }}
    >
      {/* Header compatto per mobile */}
      <Paper 
        elevation={0} 
        sx={{ 
          borderRadius: 2, 
          p: isMobile ? 2 : 3, 
          mb: isMobile ? 2 : 3,
          background: `linear-gradient(135deg, ${theme.palette.primary.main}10 0%, ${theme.palette.secondary.main}08 100%)`,
          border: `1px solid ${theme.palette.divider}`
        }}
      >
        <Stack 
          direction={isMobile ? "column" : "row"} 
          spacing={isMobile ? 1.5 : 2} 
          alignItems={isMobile ? "center" : "center"}
        >
          <Avatar 
            src={logoUrl} 
            alt={projectName} 
            sx={{ 
              width: isMobile ? 50 : 60, 
              height: isMobile ? 50 : 60,
              border: `2px solid ${theme.palette.background.paper}`,
              boxShadow: theme.shadows[2]
            }} 
          />
          <Box sx={{ textAlign: isMobile ? 'center' : 'left', flex: 1 }}>
            <Typography 
              variant={isMobile ? "h5" : "h4"}
              fontWeight="bold" 
              sx={{ 
                mb: 0.5,
                background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Dashboard Admin
            </Typography>
            <Typography 
              variant={isMobile ? "body2" : "subtitle1"}
              color="text.secondary" 
              sx={{ mb: isMobile ? 1 : 1.5 }}
            >
              {projectName || "tp-agents"} • Nuovi Frontend AI Disponibili! 🚀
            </Typography>
            <Stack 
              direction={isMobile ? "column" : "row"} 
              spacing={1}
              alignItems={isMobile ? "center" : "flex-start"}
            >
              <Chip 
                label="Admin Platform" 
                color="primary" 
                size="small"
                icon={<User size={14} />}
              />
              <Chip 
                label="3 Nuovi Frontend AI" 
                color="success" 
                size="small"
                icon={<BrainCircuit size={14} />}
              />
              {!isMobile && (
                <Chip 
                  label={`${profile?.display_name || profile?.email}`} 
                  variant="outlined" 
                  size="small"
                />
              )}
            </Stack>
          </Box>
        </Stack>
      </Paper>

      {/* Sezioni della Dashboard */}
      {Object.entries(ADMIN_SECTIONS).map(([sectionKey, section]) => (
        <Fade key={sectionKey} in timeout={300 + (parseInt(sectionKey) * 100)}>
          <div>
            <CompactAdminSection 
              section={section} 
              sectionKey={sectionKey} 
            />
          </div>
        </Fade>
      ))}

      {/* Footer con statistiche compatto - AGGIORNATO */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: isMobile ? 2 : 3, 
          mt: isMobile ? 2 : 3, 
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.default
        }}
      >
        <Grid container spacing={isMobile ? 2 : 3} justifyContent="center">
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center" spacing={0.5}>
              <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" color="primary.main">
                {Object.values(ADMIN_SECTIONS).reduce((acc, section) => acc + section.links.length, 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" textAlign="center">
                Strumenti
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center" spacing={0.5}>
              <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" color="secondary.main">
                {Object.keys(ADMIN_SECTIONS).length}
              </Typography>
              <Typography variant="caption" color="text.secondary" textAlign="center">
                Categorie
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center" spacing={0.5}>
              <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" color="success.main">
                3
              </Typography>
              <Typography variant="caption" color="text.secondary" textAlign="center">
                Frontend AI
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center" spacing={0.5}>
              <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" color="info.main">
                v1.4
              </Typography>
              <Typography variant="caption" color="text.secondary" textAlign="center">
                Versione
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}